import { GlobalContext } from "components/GlobalContext";
import IOpportunity, { IOpportunityCreateOrUpdate } from "models/sql/IOpportunity";
import { useContext, useEffect, useRef, useState } from "react";
import OpportunityService from "services/OpportunityService";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import IDealer, { IDealerFilters } from "models/sql/IDealer";
import ISalesRep, { ISalesRepFilters } from "models/sql/ISalesRep";
import IFireDepartment, { IFireDepartmentFilters } from "models/sql/IFireDepartment";
import DPSEntitySelector from "components/DPSEntitySelector";
import FireDepartmentService from "services/FireDepartmentService";
import DealerService from "services/DealerService";
import SalesRepService from "services/SalesRepService";
import ProductPricingCalculator, { IProductListEntry } from "components/ProductPricingCalculator";
import { useNavigate } from "react-router-dom";

const QuickQuote = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const [dealer, setDealer] = useState<IDealer>();
    const [initialProductList] = useState<IProductListEntry[]>([]);
    const [salesRep, setSalesRep] = useState<ISalesRep>();
    const [fireDepartment, setFireDepartment] = useState<IFireDepartment>();
    const navigate = useNavigate();
    const [Opportunity, setOpportunity] = useState<IOpportunity>({
        opportunityId: -1,
        created: undefined,
        notes: "",
        extraData: undefined,
        stage: "",
        country: "",
        state: "",
        fireDepartmentId: undefined,
        dealerId: undefined,
        meetingType: "",
        meetingStatus: "",
        meetingDate: undefined,
        pocprimaryTitle: "",
        pocprimaryName: "",
        pocprimaryEmail: "",
        pocprimaryPhone: "",
        pocsecondaryTitle: "",
        pocsecondaryName: "",
        pocsecondaryEmail: "",
        pocsecondaryPhone: "",
        poctertiaryTitle: "",
        poctertiaryName: "",
        poctertiaryEmail: "",
        poctertiaryPhone: "",
        productInfoJson: "",
        healthRiskAssessmentId: undefined,
        healthRiskAssessmentSentDate: undefined,
        airCardId: undefined,
        airCardSentDate: undefined,
        fileAttachmentsJson: undefined,
        systemDataJson: undefined,
        lastUpdated: undefined,
        lastUpdatedBy: undefined,
        createdBy: undefined,
        fundingStatus: undefined,
        salesRepId: undefined,
        departmentName: undefined,
        station: undefined,
        totalValue: undefined,
        qualified: undefined,
        quotedTotalValue: 0,
        quoteStatus: "",
        code: "",
        source: "QQ",
        likleyhood: undefined,
        timeline: undefined,
        closureDate: undefined,
        fireStationId: undefined
    });

    useEffect(
        () => {
            (async () => {
            })();
        }, []);

    const submitFormAsync = async () => {
        if (Opportunity) {
            globalContext.setLoading(true);
            const accessToken = await globalContext.getAccessTokenAsync();

            const data: IOpportunityCreateOrUpdate = {
                opportunityId: Opportunity.opportunityId,
                created: Opportunity.created,
                notes: Opportunity.notes,
                extraData: Opportunity.extraData,
                stage: Opportunity.stage,
                country: Opportunity.country,
                state: Opportunity.state,
                fireDepartmentId: Opportunity.fireDepartmentId,
                dealerId: Opportunity.dealerId,
                meetingType: Opportunity.meetingType,
                meetingStatus: Opportunity.meetingStatus,
                meetingDate: Opportunity.meetingDate,
                pocprimaryTitle: Opportunity.pocprimaryTitle,
                pocprimaryName: Opportunity.pocprimaryName,
                pocprimaryEmail: Opportunity.pocprimaryEmail,
                pocprimaryPhone: Opportunity.pocprimaryPhone,
                pocsecondaryTitle: Opportunity.pocsecondaryTitle,
                pocsecondaryName: Opportunity.pocsecondaryName,
                pocsecondaryEmail: Opportunity.pocsecondaryEmail,
                pocsecondaryPhone: Opportunity.pocsecondaryPhone,
                poctertiaryTitle: Opportunity.poctertiaryTitle,
                poctertiaryName: Opportunity.poctertiaryName,
                poctertiaryEmail: Opportunity.poctertiaryEmail,
                poctertiaryPhone: Opportunity.poctertiaryPhone,
                productInfoJson: Opportunity.productInfoJson,
                healthRiskAssessmentId: Opportunity.healthRiskAssessmentId,
                healthRiskAssessmentSentDate: Opportunity.healthRiskAssessmentSentDate,
                airCardId: Opportunity.airCardId,
                airCardSentDate: Opportunity.airCardSentDate,
                fileAttachmentsJson: Opportunity.fileAttachmentsJson,
                systemDataJson: Opportunity.systemDataJson,
                lastUpdated: Opportunity.lastUpdated,
                lastUpdatedBy: Opportunity.lastUpdatedBy,
                createdBy: Opportunity.createdBy,
                fundingStatus: Opportunity.fundingStatus,
                salesRepId: Opportunity.salesRepId,
                departmentName: Opportunity.departmentName,
                station: Opportunity.station,
                totalValue: Opportunity.totalValue,
                qualified: Opportunity.qualified,
                quotedTotalValue: Opportunity.quotedTotalValue,
                quoteStatus: Opportunity.quoteStatus,
                code: Opportunity.code,
                source: "QQ",
                likleyhood: Opportunity.likleyhood,
                timeline: Opportunity.timeline,
                closureDate: Opportunity.closureDate,
                fireStationId: Opportunity.fireStationId
            };
            var newLeadId = await OpportunityService.createQuickQuoteAsync(accessToken, data);
            globalContext.setLoading(false);
            navigate(`/Opportunities/Detail/${newLeadId}`);
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <Card.Body>
                        <Card.Title>
                            Quick Quote
                        </Card.Title>

                        <DPSEntitySelector<IFireDepartment, IFireDepartmentFilters>
                            entityFilterSearchPropName={"fireDeptNames"}
                            entityService={FireDepartmentService}
                            entityTypeName="Department"
                            defaultEntityFilter={{}}
                            selectedEntityRef={fireDepartment}
                            generateEntityTitle={(entry) => `${entry.fireDeptName} ${entry.hqcity} ${entry.hqstate}, ${entry.hqzip} ${entry.hqCountry}`}
                            onClickExternalHandler={(entry) => {
                                if (entry) {
                                    window.open(`/DPS/Departments/Detail/${entry.fireDepartmentId}`);
                                }
                            }}
                            onClickAddNewHandler={() => {
                                window.open(`/DPS/Departments/Detail/?defs={"fireDeptName":"${Opportunity.departmentName ?? ""}","hqstate":"${Opportunity.state ?? ""}","hqCountry":"${Opportunity.country ?? ""}"}`);
                            }}
                            entityChangeHandler={(newEntry) => {
                                setOpportunity({ ...Opportunity, fireDepartmentId: newEntry?.fireDepartmentId || undefined });
                                setFireDepartment(newEntry);
                            }}
                        />

                        <DPSEntitySelector<IDealer, IDealerFilters>
                            entityFilterSearchPropName={"dealerNames"}
                            entityService={DealerService}
                            entityTypeName="Dealer"
                            defaultEntityFilter={{}}
                            selectedEntityRef={dealer}
                            generateEntityTitle={(entry) => entry.dealerName ?? ""}
                            onClickExternalHandler={(entry) => {
                                if (entry) {
                                    window.open(`/DPS/Dealers/Detail/${entry.dealerId}`);
                                }
                            }}
                            entityChangeHandler={(newEntry) => {
                                setOpportunity({ ...Opportunity, dealerId: newEntry?.dealerId || undefined });
                                setDealer(newEntry);
                            }}
                        />

                        <DPSEntitySelector<ISalesRep, ISalesRepFilters>
                            entityFilterSearchPropName={"names"}
                            entityService={SalesRepService}
                            entityTypeName="Rep"
                            defaultEntityFilter={{ dealerIds: dealer ? [dealer.dealerId] : undefined }}
                            selectedEntityRef={salesRep}
                            generateEntityTitle={(entry) => entry?.fullName ?? ""}
                            onClickExternalHandler={(entry) => {
                                if (entry) {
                                    window.open(`/DPS/Reps/Detail/${entry.salesRepId}`);
                                }
                            }}
                            entityChangeHandler={(newEntry) => {
                                setOpportunity({ ...Opportunity, salesRepId: newEntry?.salesRepId || undefined });
                                setSalesRep(newEntry);
                            }}
                        />

                        <Row className="mt-2">
                            <Col>
                                <Form.Group >
                                    <Form.Label>POC Primary Name</Form.Label>
                                    {
                                        <Form.Control
                                            type="text"
                                            onChange={
                                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                                    setOpportunity({ ...Opportunity, pocprimaryName: e.target.value });
                                                }
                                            }
                                            value={Opportunity.pocprimaryName}
                                        />
                                    }
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>POC Primary Title</Form.Label>
                                    {
                                        <Form.Control
                                            type="text"
                                            onChange={
                                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                                    setOpportunity({ ...Opportunity, pocprimaryTitle: e.target.value });
                                                }
                                            }
                                            value={Opportunity.pocprimaryTitle}
                                        />
                                    }
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>POC Primary Email</Form.Label>
                                    {
                                        <Form.Control
                                            type="text"
                                            onChange={
                                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                                    setOpportunity({ ...Opportunity, pocprimaryEmail: e.target.value });
                                                }
                                            }
                                            value={Opportunity.pocprimaryEmail}
                                        />
                                    }
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>POC Primary Phone</Form.Label>
                                    {
                                        <Form.Control
                                            type="text"
                                            onChange={
                                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                                    setOpportunity({ ...Opportunity, pocprimaryPhone: e.target.value });
                                                }
                                            }
                                            value={Opportunity.pocprimaryPhone}
                                        />
                                    }
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <ProductPricingCalculator
                                    className="mt-4 mb-4"
                                    title="Products"
                                    hideEmailButton={true}
                                    hidePrintButton={true}
                                    rep={salesRep}
                                    dealer={dealer}
                                    includeDiscounts={false}
                                    initialProductList={initialProductList}
                                    onChange={newProductList => {
                                        let newSystemDataJSON = JSON.parse(Opportunity.systemDataJson || "{}");
                                        newSystemDataJSON.publicProductList = newProductList;
                                        setOpportunity({ ...Opportunity, systemDataJson: JSON.stringify(newSystemDataJSON) });
                                    }}
                                    onTotalChange={(newTotal, newProductList) => {
                                        let newSystemDataJSON = JSON.parse(Opportunity.systemDataJson || "{}");
                                        newSystemDataJSON.publicProductList = newProductList;
                                        setOpportunity({ ...Opportunity, quotedTotalValue: newTotal, systemDataJson: JSON.stringify(newSystemDataJSON) });
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row className="align-items-end">
                            <Col>
                                <Button
                                    style={{ width: "100%", height: "60px" }}
                                    onClick={
                                        () => submitFormAsync()}>Create Quick Quote</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Col>
            </Row>
        </>
    );
}

export default QuickQuote;
